import { atom } from 'jotai';

export const sideMenuForceOpen = atom<boolean>(false);
